import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Input, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { InputField, DisabledInputField} from '../Common/inputField';
import { Selection } from '../Common/selection';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'



class ScrapRecordForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            inventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            scrappedInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchProducts();
        if(this.props.currentScrapRecord){
          this.props.fetchScrapRecordDetail(this.props.currentScrapRecord.WarehouseScrap_id);
        }
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if(nextProps.currentScrapRecordDetail && nextProps.currentScrapRecordDetail != this.props.currentScrapRecordDetail){
          let newScrappedInventories = nextProps.currentScrapRecordDetail.Warehouse_Scrap_Line;
          newScrappedInventories.map(newScrappedInventory => {
            let Batch_PONum = newScrappedInventory.Batch_PONum;
            let ProductNum = newScrappedInventory.ProductNum;
            let WarehouseZone_id = newScrappedInventory.WarehouseZone_id.WarehouseZone_id;
            let WarehouseBin_id = newScrappedInventory.WarehouseBin_id.WarehouseBin_id;
            let id = Batch_PONum + ProductNum + WarehouseZone_id + WarehouseBin_id;
            newScrappedInventory["Inventory_id"] = id;
            newScrappedInventory["ZoneName"] = newScrappedInventory.WarehouseZone_id.Name;
            newScrappedInventory["BinName"] = newScrappedInventory.WarehouseBin_id.Name;
            newScrappedInventory["WarehouseZone_id"] = WarehouseZone_id;
            newScrappedInventory["WarehouseBin_id"] = WarehouseBin_id;
          })
          const scrappedInventories = {...this.state.scrappedInventories,
            rows: newScrappedInventories }
          this.setState({
            scrappedInventories: scrappedInventories
          });
        }
        if (nextProps.scrapRecordsInventories && nextProps.scrapRecordsInventories != this.props.scrapRecordsInventories) {
            let newInventories = nextProps.scrapRecordsInventories;
            newInventories.map(newInventory => {
              let Batch_PONum = newInventory.Batch_PONum;
              let ProductNum = newInventory.ProductNum;
              let WarehouseZone_id = newInventory.WarehouseZone_id.WarehouseZone_id;
              let WarehouseBin_id = newInventory.WarehouseBin_id.WarehouseBin_id;
              let id = Batch_PONum + ProductNum + WarehouseZone_id + WarehouseBin_id;
              newInventory["Inventory_id"] = id;
              newInventory["ZoneName"] = newInventory.WarehouseZone_id.Name;
              newInventory["BinName"] = newInventory.WarehouseBin_id.Name;
              newInventory["WarehouseZone_id"] = WarehouseZone_id;
              newInventory["WarehouseBin_id"] = WarehouseBin_id;
            })
            const inventories = {...this.state.inventories, rows: newInventories }
            this.setState({
                inventories: inventories
            });
        }
        if (nextProps.productValue != this.props.productValue) {
          this.props.fetchInventoryScrap(nextProps.productValue.value || nextProps.productValue);
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    renderHeader() {
      let header = (this.props.currentScrapRecordDetail) ? "edit_scrap_record" : "new_scrap_record"
      return (
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="warehouse_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={header} />
          </Breadcrumb.Item>
        </Breadcrumb>
      )
    }

    setInventoryToScrap(e) {
        e.preventDefault();
        const { inventories, scrappedInventories } = this.state;
        const inventoryToLocate = { ...inventories.selectedRows[0],
            // ToZone: this.props.toZoneValue,
            // ToBin: this.props.toBinValue,
            Quantity: this.props.quantityValue,
            // newQuantity: inventories.selectedRows[0].Quantity + this.props.quantityValue
            // NewQuantity: this.props.quantityValue,
            // Product_id:
        };

        const newScrappedInventories = { ...scrappedInventories };
        // const newInventories = { ...inventories };
        newScrappedInventories.rows.push(inventoryToLocate)

        // const index = _.findIndex(inventories.rows, { 'Inventory_id': inventories.selectedRows[0].Inventory_id });
        // if (index > -1) {
        //     newInventories.rows.splice(index, 1);
        // }
        // newInventories.selectedRows = [];
        this.setState({
            scrappedInventories: newScrappedInventories
        })
    }

    cancelScrapRecord(e) {
        e.preventDefault();
        const { inventories, scrappedInventories } = this.state;
        const inventoryToCancel = { ...scrappedInventories.selectedRows[0] };

        const newScrappedInventories = { ...scrappedInventories };
        // const newInventories = { ...inventories };
        // newInventories.rows.push(inventoryToCancel)

        const index = _.findIndex(scrappedInventories.rows, { 'Inventory_id': scrappedInventories.selectedRows[0].Inventory_id });
        if (index > -1) {
            newScrappedInventories.rows.splice(index, 1);
        }
        newScrappedInventories.selectedRows = [];
        this.setState({
            scrappedInventories: newScrappedInventories
        })
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.inventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ inventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.inventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const inventories = {...this.state.inventories, filters: newFilters }
                this.setState({ inventories });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const inventories = {...this.state.inventories, selectedRows: rows }
                this.setState({ inventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                // {
                //     key: 'ProductNum',
                //     name: 'No.',
                //     resizable: true,
                //     sortable: true,
                //     filterable: true
                // },
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    width: 130,
                    filterable: true
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'ProductUnitOfMeasure',
                    name: <Translate value="mm_unit" />,
                    resizable: true,
                    sortable: true,
                    width: 225,
                    filterable: true
                },
                {
                    key: 'ExpiredDate',
                    name: <Translate value="expired_date" />,
                    resizable: true,
                    sortable: true,
                    width: 140,
                    filterable: true,
                    formatter: DateFormatter
                },
                {
                    key: 'Pallet',
                    name: <Translate value="pallet" />,
                    resizable: true,
                    sortable: true,
                    width: 70,
                    filterable: true
                },
                {
                    key: 'ZoneName',
                    name: <Translate value="zone_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'BinName',
                    name: <Translate value="bin_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'BinAmount',
                    name: <Translate value="bin_amount" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Batch_PONum',
                    name: <Translate value="batch_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="ScrapRecordForm-dataGrid1">
                    <ReactDataGrid
                        rowKey='Inventory_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={300}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderScrappedTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.scrappedInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var scrappedInventories = {...this.state.scrappedInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ scrappedInventories: scrappedInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.scrappedInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const scrappedInventories = {...this.state.scrappedInventories, filters: newFilters }
                this.setState({ scrappedInventories: scrappedInventories });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let { scrappedInventories } = this.state
                let rows = scrappedInventories.rows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                }
                const newScrappedInventories = {...scrappedInventories, rows: rows }
                this.setState({
                    scrappedInventories: newScrappedInventories
                });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let { scrappedInventories } = this.state
                let rows = scrappedInventories.rows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                const newScrappedInventories = {...scrappedInventories, rows: rows }
                this.setState({
                    scrappedInventories: newScrappedInventories,
                });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const scrappedInventories = {...this.state.scrappedInventories, selectedRows: rows };
                this.setState({ scrappedInventories: scrappedInventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    width: 230,
                    filterable: true
                },
                {
                    key: 'Quantity',
                    name: <Translate value="scrap_qty" />,
                    resizable: true,
                    width: 100,
                    filterable: true,
                    editable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="ScrapRecordForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='Inventory_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={200}
                        enableRowSelect='single'
                        onCellsDragged={handleCellDrag}
                        enableCellSelect={true}
                        onRowUpdated={handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    getProductNumOptions() {
      var productNumOptions = [];
      this.props.products.map(product => {
          productNumOptions.push({ value: product.ProductNum, label: product.Name })
      });
      return productNumOptions;
    }

    handleFormSubmit(formProps) {
      if(this.props.currentScrapRecord){
        if(!checkPermission("change_warehouse_scrap"))
          this.props.editScrapRecord(this.props.currentScrapRecord.WarehouseScrap_id, formProps, 1, Data.Selectors.getRows(this.state.scrappedInventories));
        else
          alert("You have no permission!");
      }
      else
        this.props.createScrapRecord(formProps, 1, Data.Selectors.getRows(this.state.scrappedInventories));
    }

    render() {
        const inventoryScrapWarehouseLoc = (<Translate value="inventory_scrap_warehouse_location" />);
        const inventoryScrapSheetWarehouseloc = (<Translate value="inventory_scrap_sheet_warehouse_location" />);
        const { inventories, scrappedInventories } = this.state;
        const { handleSubmit, submitting, pristine } = this.props;
        let productNumOptions = this.getProductNumOptions();
        return (
            <ContentWrapper>
              {this.renderHeader()}
              <Grid id="inventory-scrap-form">
                <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                  <ButtonToolbar id="breadcrumbButtonGroup">
                      <Button onClick={() => { this.context.router.push('/scrapRecords')}}  bsStyle="danger" ><em className="fa fa-close"/></Button>
                      <Button bsStyle="success" type="submit"><em className="fa fa-save marginRightStyle"/><Translate value="save" /></Button>
                  </ButtonToolbar>
                  <Row className="marginTopStyle">
                    <Panel id="scrap-select-product">
                      <Row>
                        <div className="col-sm-6">
                            <label className="col-sm-4 inlineLabel" ><Translate value="select_a_product_to_scrap" /> <span style={{color: 'red'}} >*</span> </label>
                            <Col sm={ 6 }>
                              <Field name="ProductNum" component={Selection} options={productNumOptions}/>
                            </Col>
                        </div>
                        <div className="col-sm-offset-3 col-sm-3">
                          <label className="col-sm-6 inlineLabel" ><Translate value="scrap_date" /> <span style={{color: 'red'}} >*</span> </label>
                          <Col sm={ 6 }>
                            <Field name="PostingDate" selected={new Date} component={DisabledDatePicker}  />
                          </Col>
                        </div>
                      </Row>
                    </Panel>
                  </Row>
                  <Row className="marginTopStyle">
                    <h2><Translate value="select_inventory_to_scrap" /></h2>
                    <Panel id="scrap-select-inventory">
                        {this.renderTable() }
                    </Panel>
                  </Row>
                  <Row>
                    <Col sm={ 6 } className="pl0">
                      <h2><Translate value="scrap_product_details" /></h2>
                      <Panel id="scrap-product-details">
                        <h4><Translate value="scrapping" /></h4>
                        <Row><p><Translate value="msg_enter_scrap_amount_and_inventory_will_be_updated" /></p></Row>
                        <Row>
                            <div className="col-sm-7 mb">
                                <Row><label><Translate value="product_name" /></label></Row>
                                <Row><Field component={DisabledInputField} placeholder={inventories.selectedRows[0] && inventories.selectedRows[0].ProductName} /></Row>
                            </div>
                            <div className="col-sm-offset-1 col-sm-3 mb">
                                <Row><label><Translate value="scrap_amount" /></label></Row>
                                <Row><Field component={InputField} name="Quantity"></Field></Row>
                                <Row>
                                    {inventories.selectedRows[0] &&
                                        parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].BinAmount) &&
                                        <p className="parsley-error-message"><Translate value="msg_scrap_qty_cannot_exceed_current_qty" /></p>}
                                </Row>
                            </div>
                            <div className="col-sm-1 scrap-amount mb">
                              <Button
                                  bsStyle="primary"
                                  onClick={(e) => this.setInventoryToScrap(e) }
                                  disabled={ !inventories.selectedRows[0]}><em className="fa fa-share" /></Button>
                            </div>
                            <div className="col-sm-4 mb">
                                <Row><label><Translate value="batch_num" /> (<Translate value="po_num" />)</label></Row>
                                <Row>{inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : <Translate value="please_select_inventory" />}</Row>
                            </div>
                            <div className="col-sm-4 mb">
                                <Row><label><Translate value="in_stock" /></label></Row>
                                <Row>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : <Translate value="please_select_inventory" />}</Row>
                            </div>
                        </Row>
                      </Panel>
                    </Col>
                    <Col sm={ 6 } className="pr0">
                      <h2><Translate value="scrap_record" /></h2>
                      <Panel id="scrap-record">
                          {this.renderScrappedTable() }
                          <button
                              className="btn btn-warning pull-right marginTopStyle"
                              onClick={(e) => this.cancelScrapRecord(e) }
                              disabled={ !scrappedInventories.selectedRows[0]}><Translate value="cancel" /></button>
                      </Panel>
                    </Col>
                  </Row>
                </form>
              </Grid>
            </ContentWrapper>
        );
    }
}



export default ScrapRecordForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/scrapRecordForm.jsx